// extracted by mini-css-extract-plugin
export default {"selectable":"ActivityFeedEvent_selectable__5sX4y","trimText":"ActivityFeedEvent_trimText__dc1Xb"};